import {
    CreditCardIcon,
    CurrencyDollarIcon,
    HouseIcon,
    InvoiceIcon,
    PenNibIcon,
    SolarPanelIcon,
    SparkleIcon,
    SquaresFourIcon,
    UserPlusIcon,
} from '@phosphor-icons/react';

/** Left-rail dashboard sections: one panel at a time, or `all` for the full grid. */
export type DashboardSectionPanelId =
    | 'all'
    | 'customer'
    | 'utility'
    | 'designs'
    | 'financing'
    | 'system'
    | 'refer'
    | 'quotes'
    | 'agreements';

export type DashboardSectionNavItem = {
    id: DashboardSectionPanelId;
    /** Shown in tooltips and for accessibility */
    label: string;
    /** Uppercase label under icon on expanded section rail */
    railLabel: string;
    Icon: typeof HouseIcon;
    /** Omit from the floating section rail (e.g. full dashboard grid) */
    hideFromRail?: boolean;
    /** Highlighted “card” treatment for the first item (full dashboard) */
    railVariant?: 'card';
    railSepAfter?: boolean;
    railSepBefore?: boolean;
};

/**
 * Rail order: Full dashboard → AI Designs → Opportunity → Utility → System →
 * Quotes → Agreements → Stripe → Refer a friend.
 */
export const DASHBOARD_SECTION_NAV_ITEMS: ReadonlyArray<DashboardSectionNavItem> = [
    {
        id: 'all',
        label: 'Full dashboard',
        railLabel: 'ALL',
        Icon: SquaresFourIcon,
        railVariant: 'card',
    },
    {
        id: 'designs',
        label: 'AI Designs',
        railLabel: 'AI DESIGN',
        Icon: SparkleIcon,
    },
    {
        id: 'customer',
        label: 'Opportunity & contacts',
        railLabel: 'OPPORTUNITY',
        Icon: HouseIcon,
    },
    {
        id: 'utility',
        label: 'Utility details',
        railLabel: 'UTILITY',
        Icon: InvoiceIcon,
    },
    {
        id: 'system',
        label: 'System & design',
        railLabel: 'SYSTEM',
        Icon: SolarPanelIcon,
    },
    {
        id: 'quotes',
        label: 'Quotes',
        railLabel: 'QUOTES',
        Icon: CurrencyDollarIcon,
    },
    {
        id: 'agreements',
        label: 'Agreements',
        railLabel: 'AGREEMENTS',
        Icon: PenNibIcon,
    },
    {
        id: 'financing',
        label: 'Financing options',
        railLabel: 'STRIPE',
        Icon: CreditCardIcon,
    },
    {
        id: 'refer',
        label: 'Refer a friend',
        railLabel: 'REFER A FRIEND',
        Icon: UserPlusIcon,
    },
];
